import {WorkforceProfileWizardMetadataFields} from '../WorkforceProfileWizardMetadataFields';

import {SupportedLanguages} from '../../../../../../types/SupportedLanguages';
import {Department} from '../../../../profile/types';
import {DepartmentTargetProfileAssignment} from '../../../types/DepartmentTargetProfileTypes';
import type {WorkforceProfileResearchLookup, WorkforceProfileWizardSetup} from '../../../types/workforceProfileWizardTypes';

export interface Props {
  departments: Department[];
  currentLanguage: SupportedLanguages;
  setup: WorkforceProfileWizardSetup;
  lookup: WorkforceProfileResearchLookup;
  departmentTargetProfiles: DepartmentTargetProfileAssignment[];
  isTargetProfilesLoading: boolean;
  isTargetProfilesError: boolean;
  onSetupChange: (setup: WorkforceProfileWizardSetup) => void;
  onLookupChange: (lookup: WorkforceProfileResearchLookup) => void;
}

export const WorkforceProfileWizardSetupStep = ({
  departments,
  currentLanguage,
  setup,
  lookup,
  departmentTargetProfiles,
  isTargetProfilesLoading,
  isTargetProfilesError,
  onSetupChange,
  onLookupChange,
}: Props) => (
  <WorkforceProfileWizardMetadataFields
    departments={departments}
    currentLanguage={currentLanguage}
    setup={setup}
    lookup={lookup}
    departmentTargetProfiles={departmentTargetProfiles}
    isTargetProfilesLoading={isTargetProfilesLoading}
    isTargetProfilesError={isTargetProfilesError}
    showLookupFields
    onSetupChange={onSetupChange}
    onLookupChange={onLookupChange}
  />
);
